<div class="row">
	<span class="row-left">
		<ng-content select="[left]"></ng-content>
	</span>
	<span class="row-right">
		<ng-content select="[right]"></ng-content>
	</span>
</div>
